module.exports = __webpack_public_path__ + "static/turquia-024-6e07d9b0d5273d9a04daf60cf08d6b56.jpg";